import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Button,
  Heading,
  ItemListItem,
  ItemListHeadingContainer,
  ItemListHeading,
  ItemListActionContainer,
  Checkbox,
  BackButton,
} from 'prospect-path-components';

const Container = styled.div`
    max-width: 25rem;
    margin-left: auto;
    margin-right: auto;
`;

const ImageContainer = styled.div`
    padding: 1.8rem 0;
`;

const ContainerBody = styled.div`
    padding-top: 20%;
`;

export default class TeamProducts extends Component {
  render() {
    return (
      <div>
        <Container>
          <ImageContainer>
            <img src="/images/logo.svg" />
          </ImageContainer>

          <ContainerBody>
            <BackButton>Back</BackButton>
            <Heading>Sage UK</Heading>

            <div>
              <ItemListItem>
                <ItemListHeadingContainer>
                  <ItemListHeading>
                    Product A
                  </ItemListHeading>
                </ItemListHeadingContainer>
                <ItemListActionContainer>
                  <Checkbox checked disabled />
                </ItemListActionContainer>
              </ItemListItem>
              <ItemListItem>
                <ItemListHeadingContainer>
                  <ItemListHeading>
                    Product B
                  </ItemListHeading>
                </ItemListHeadingContainer>
                <ItemListActionContainer>
                  <Checkbox checked disabled />
                </ItemListActionContainer>
              </ItemListItem>
              <ItemListItem>
                <ItemListHeadingContainer>
                  <ItemListHeading>
                    Product C
                  </ItemListHeading>
                </ItemListHeadingContainer>
                <ItemListActionContainer>
                  <Checkbox checked disabled />
                </ItemListActionContainer>
              </ItemListItem>
              <ItemListItem>
                <ItemListHeadingContainer>
                  <ItemListHeading>
                    Product D
                  </ItemListHeading>
                </ItemListHeadingContainer>
                <ItemListActionContainer>
                  <Checkbox checked disabled />
                </ItemListActionContainer>
              </ItemListItem>
              <ItemListItem>
                <ItemListHeadingContainer>
                  <ItemListHeading>
                    Product E
                  </ItemListHeading>
                </ItemListHeadingContainer>
                <ItemListActionContainer>
                  <Checkbox checked disabled />
                </ItemListActionContainer>
              </ItemListItem>
            </div>

            <Button style={{ marginTop: '2rem' }} block color="primary">Join Team</Button>
          </ContainerBody>
        </Container>
      </div>
    );
  }
}

